import { Notices } from "@/lib/notices"

import { NoticeListComponent } from "@/components/Notice/List/component"

export const NoticeListConsumer = Notices.consume(NoticeListComponent)
